import { FC } from "react";

import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { brandColorTokens } from "@constants";

import { IFooterLinkGroupProperties } from "./FooterLinkGroup.types";

const FooterLinkGroup: FC<IFooterLinkGroupProperties> = ({ group }) => {
  const { t } = useTranslation();

  return (
    <Box component="nav" aria-label={t(group.titleKey)}>
      <Typography component="h2" variant="subtitle1" sx={{ color: brandColorTokens.text.display, mb: 2 }}>
        {t(group.titleKey)}
      </Typography>
      <Box component="ul" sx={{ display: "flex", flexDirection: "column", gap: 1.25, listStyle: "none", m: 0, p: 0 }}>
        {group.links.map((link) => (
          <li key={link.labelKey}>
            <Link href={link.href} underline="none" sx={{ color: "text.secondary" }}>
              {t(link.labelKey)}
            </Link>
          </li>
        ))}
      </Box>
    </Box>
  );
};

export default FooterLinkGroup;
